/** @internal */
export class Versioned<out A> {
  constructor(readonly value: A) {}
}
